// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"3f15844e","56":"0f185ab1","103":"c47860ff","532":"138bbffe","543":"c47860ff"}[chunkId] + ".chunk.css";
};